import { ActionsUnion, createAction } from "store/helper";

export enum ShortcutsActionNames {
  DISABLE = "FEATURES/SHORTCUTS/DISABLE",
  ENABLE = "FEATURES/SHORTCUTS/ENABLE",
}

export const ShortcutsActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  enable: () => createAction(ShortcutsActionNames.ENABLE),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  disable: () => createAction(ShortcutsActionNames.DISABLE),
};

export type ShortcutsAction = ActionsUnion<typeof ShortcutsActions>;
